import { Link } from 'react-router-dom';
import { ArrowRight, Play, Shield, Zap, Lock } from 'lucide-react';
import styles from './Hero.module.css';

export default function Hero() {
	return (
		<section className={styles.hero}>
			<div className={styles.background}>
				<div className={styles.gradient} />
				<div className={styles.grid} />
			</div>

			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.badge}>
						<Shield size={14} />
						<span>Enterprise-Grade Crypto Gaming</span>
					</div>

					<h1 className={styles.title}>
						The Complete Platform for{' '}
						<span className={styles.highlight}>Crypto Gaming</span> Operators
					</h1>

					<p className={styles.subtitle}>
						Launch provably fair casino games in minutes. Seamless wallet integration,
						real-time analytics, and instant settlements. Built for operators who
						demand reliability and scale.
					</p>

					<div className={styles.actions}>
						<Link to="/docs/quickstart" className={styles.primaryButton}>
							Get Started
							<ArrowRight size={18} />
						</Link>
						<a
							href="https://play.rngfort.com"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.secondaryButton}
						>
							<Play size={18} />
							Try Demo
						</a>
					</div>

					<div className={styles.quickLinks}>
						<a
							href="https://admin.rngfort.com"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.quickLink}
						>
							<Shield size={14} />
							Admin Dashboard
						</a>
						<a
							href="https://operator.rngfort.com"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.quickLink}
						>
							<Zap size={14} />
							Operator Dashboard
						</a>
						<Link to="/docs" className={styles.quickLink}>
							<Lock size={14} />
							API Documentation
						</Link>
					</div>

					<div className={styles.stats}>
						<div className={styles.stat}>
							<span className={styles.statValue}>99.99%</span>
							<span className={styles.statLabel}>Uptime SLA</span>
						</div>
						<div className={styles.statDivider} />
						<div className={styles.stat}>
							<span className={styles.statValue}>&lt;50ms</span>
							<span className={styles.statLabel}>Latency</span>
						</div>
						<div className={styles.statDivider} />
						<div className={styles.stat}>
							<span className={styles.statValue}>4+</span>
							<span className={styles.statLabel}>Game Types</span>
						</div>
					</div>
				</div>

				<div className={styles.visual}>
					<div className={styles.card}>
						<div className={styles.cardHeader}>
							<div className={styles.cardDot} />
							<div className={styles.cardDot} />
							<div className={styles.cardDot} />
						</div>
						<div className={styles.cardContent}>
							<div className={styles.codeBlock}>
								<code className={styles.code}>
									<span className={styles.keyword}>const</span>{' '}
									<span className={styles.variable}>session</span>{' '}
									<span className={styles.operator}>=</span>{' '}
									<span className={styles.keyword}>await</span>{' '}
									<span className={styles.function}>ringfort</span>
									<span className={styles.punctuation}>.</span>
									<span className={styles.method}>createSession</span>
									<span className={styles.punctuation}>(</span>
									<span className={styles.punctuation}>{'{'}</span>
									<br />
									<span className={styles.indent}>
										<span className={styles.property}>playerId</span>
										<span className={styles.punctuation}>:</span>{' '}
										<span className={styles.string}>"player_123"</span>
										<span className={styles.punctuation}>,</span>
									</span>
									<br />
									<span className={styles.indent}>
										<span className={styles.property}>currency</span>
										<span className={styles.punctuation}>:</span>{' '}
										<span className={styles.string}>"USDT"</span>
										<span className={styles.punctuation}>,</span>
									</span>
									<br />
									<span className={styles.indent}>
										<span className={styles.property}>balance</span>
										<span className={styles.punctuation}>:</span>{' '}
										<span className={styles.number}>1000.00</span>
									</span>
									<br />
									<span className={styles.punctuation}>{'}'}</span>
									<span className={styles.punctuation}>)</span>
									<span className={styles.punctuation}>;</span>
								</code>
							</div>
							<div className={styles.featureList}>
								<div className={styles.feature}>
									<Zap size={16} className={styles.featureIcon} />
									<span>Instant Integration</span>
								</div>
								<div className={styles.feature}>
									<Lock size={16} className={styles.featureIcon} />
									<span>Secure by Default</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
